(function () {
    'use strict';

    angular
        .module('app')
        .controller('BookingController', BookingController);

    BookingController.$inject = ['$scope', '$rootScope' , 'localization', '$http'];

    function BookingController($scope, $rootScope, localization, $http) {
        var vm = this;
        vm.$onInit = init;
        $rootScope.header_inverted = true;
        $rootScope.dark_text_header = false;
        $scope.myname = "";
        $scope.firstname = "";
        $scope.phone = "";
        $scope.email = "";

        $scope.showContactForm = true;

        function init() {

        }

        $scope.submitContactForm = function (){
            var data = {
                'myname': $scope.myname,
                'firstname': $scope.firstname,
                'phone': $scope.phone,
                'email': $scope.email,
            }

            return $http.post('api/contact', data)
                .finally(function (response) {
                    $scope.showContactForm = false;
                });
        }

    }
})();
